import Chart from "components/common/Chart";
import Grid from "components/common/Grid";
import Tab from "components/common/Tab";
import TabPanel from "components/common/TabPanel";
import JarvisCard from "components/JarvisCard";
import DashboardChartCard from "components/Dashboard/DashboardChartCard";
import React from "react";
import { localStore } from "stores/localStorage";
import MobileResponsive from "components/common/MobileResponsive";
import RMSDashboardStats from "components/RMSDashboard/RMSDashboardStats";
import MobileRMSDashboardStats from "components/RMSDashboard/MobileRMSDashboardStats";

class RMSPortfolioAnalyseDataContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPortfolioId: "overall",
      isInitialPortfolioSet: false,
      sectorChartData: [],
      marketChartData: [],
    };
  }

  componentDidMount() {
    this.props.getMarketCapDataAction();
    this.props.getSectorDiversificationAction();
    this.props.getRMSAction();
  }

  componentDidUpdate() {
    const { marketCapStats, sectorDiversificationStats } = this.props;
    const { portfolios } = this.props.portfoliosStats;

    if (
      portfolios.length &&
      marketCapStats.portfolios.length > 0 &&
      sectorDiversificationStats.portfolios.length > 0 &&
      !this.state.isInitialPortfolioSet &&
      this.state.selectedPortfolioId !== "overall"
    ) {
      this.getFirstPortfolio();
    }
  }

  getFirstPortfolio = () => {
    const { portfolios } = this.props.marketCapStats;
    const firstPortfoloId = portfolios[0]?.portfolioId;
    this.setState(
      {
        selectedPortfolioId: firstPortfoloId,
        isInitialPortfolioSet: true,
      },
      () => {
        this.getCurrentPortfolioChartData();
      }
    );
  };

  handleTabChange = (e, portfolioId) => {
    this.setState({ selectedPortfolioId: portfolioId }, () => {
      this.getCurrentPortfolioChartData();
    });
  };

  getCurrentPortfolioChartData = () => {
    const { marketCapStats, sectorDiversificationStats } = this.props;
    const { selectedPortfolioId } = this.state;

    if (selectedPortfolioId === "overall") {
      this.setState({
        marketChartData: [],
        sectorChartData: [],
      });
      return;
    }

    const currentMarketChart = marketCapStats.portfolios.find(
      (item) => item.portfolioId === selectedPortfolioId
    );

    const currentSectorChart = sectorDiversificationStats.portfolios.find(
      (item) => item.portfolioId === selectedPortfolioId
    );

    this.setState({
      marketChartData: currentMarketChart?.stats || [],
      sectorChartData: currentSectorChart?.stats || [],
    });
  };

  render() {
    const isMobileView = localStore.getMobileView();
    const getChartOptions = (title, stats) => {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        title: {
          text: "",
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: !isMobileView ? true : false,
              format: "<b>{point.name}</b>",
            },
            showInLegend: true,
          },
        },
        series: [
          {
            name: "Industry",
            colorByPoint: true,
            data: stats?.map((e) => ({
              name: e.label,
              y: e.value,
              sliced: true,
              selected: true,
            })),
          },
        ],
      };
    };

    const { selectedPortfolioId, sectorChartData, marketChartData } =
      this.state;

    const rmsDataArray = Object.values(this.props.rmsTabData);

    const tabs = [
      ...rmsDataArray.map((portfolio) => ({
        label: portfolio.portfolioName,
        portfolioId: portfolio.portfolioId || "overall",
      })),
    ];

    const {
      isPortfolioLoading,
      isRmsCallLoading,
      portfoliosStats,
      rmsCallStats,
    } = this.props;

    return (
      <JarvisCard>
        <Tab
          tabs={tabs}
          onChange={this.handleTabChange}
          value={selectedPortfolioId}
        >
          {tabs.map((item, i) => (
            <TabPanel
              sx={{ padding: "0" }}
              key={`tab_${i}`}
              value={item.portfolioId}
            >
              <Grid container spacing={2} mr={0} mt={2}>
                <Grid item xs={12} mb={2}>
                  <MobileResponsive
                    web={() => (
                      <RMSDashboardStats
                        isPortfolioLoading={isPortfolioLoading}
                        isRmsCallLoading={isRmsCallLoading}
                        portfolioStats={rmsDataArray[i]}
                        rmsCallStats={rmsDataArray[i].rmsCallStats}
                      />
                    )}
                    mobile={() => (
                      <MobileRMSDashboardStats
                        isPortfolioLoading={isPortfolioLoading}
                        isRmsCallLoading={isRmsCallLoading}
                        portfolioStats={rmsDataArray[i]}
                        rmsCallStats={rmsDataArray[i].rmsCallStats}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} lg={6} md={6}>
                  <DashboardChartCard
                    sx={{ border: "1.5px solid #F5F5F5" }}
                    title="Sector Diversification"
                    renderChart={
                      <Chart
                        options={
                          rmsDataArray[i].portfolioBySector &&
                          rmsDataArray[i].portfolioBySector.length
                            ? getChartOptions(
                                "Sector Diversification",
                                rmsDataArray[i].portfolioBySector
                              )
                            : {}
                        }
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} lg={6} md={6}>
                  <DashboardChartCard
                    sx={{ border: "1.5px solid #F5F5F5" }}
                    title="Market Cap Diversification"
                    renderChart={
                      <Chart
                        options={
                          rmsDataArray[i].portfolioByMarketCap &&
                          rmsDataArray[i].portfolioByMarketCap
                            ? getChartOptions(
                                "Market Cap Diversification",
                                rmsDataArray[i].portfolioByMarketCap
                              )
                            : {}
                        }
                      />
                    }
                  />
                </Grid>
              </Grid>
            </TabPanel>
          ))}
        </Tab>
      </JarvisCard>
    );
  }
}

export default RMSPortfolioAnalyseDataContainer;
